import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';

@Component({
  selector: 'app-dashboard-superadmin',
  templateUrl: './dashboard-superadmin.component.html',
  styleUrls: ['./dashboard-superadmin.component.css']
})
export class DashboardSuperadminComponent implements OnInit {
  myFormMonth: FormGroup;
  currentDate:any;
  selectedMonth:any;
  constructor() { 
    this.currentDate = new Date();
    let month = new FormControl(this.currentDate.getMonth()+1, Validators.required);
      this.myFormMonth = new FormGroup({
        month: month
      });
      this.selectedMonth = this.currentDate.getMonth()+1;
  }

  ngOnInit() {
  }
  monthlyInsight(event)
  {
    this.selectedMonth =  event.target.value;
    //console.log("selectedMonth",this.selectedMonth);
  }
}



// WEBPACK FOOTER //
// E:/Office Projects/Paarsel/paarsel_business_web/paarsel_business_web/src/app/logistics-operations/dashboard-main/dashboard-superadmin/dashboard-superadmin.component.ts